import { render, staticRenderFns } from "./NewSuccess.vue?vue&type=template&id=0390a29a&"
import script from "./NewSuccess.vue?vue&type=script&lang=js&"
export * from "./NewSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports